var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCriticalUpdates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "2 3 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.3999 5.50156H6.1999C5.8999 5.50156 5.8999 5.80156 5.8999 6.00156V20.5016C5.8999 20.7016 6.0999 20.9016 6.2999 20.9016H14.9999C14.9999 20.9016 14.9999 20.9016 15.0999 20.9016H15.1999C15.1999 20.9016 17.2671 18.2407 18.2999 16.9016V16.8016V5.80156C18.2999 5.60156 18.0999 5.40156 17.8999 5.40156H15.7999M8.3999 5.50156V5.90156C8.3999 6.10156 8.5999 6.30156 8.7999 6.30156H12.0499H15.2999C15.4999 6.30156 15.6999 6.10156 15.6999 5.90156V5.40156V4.90156C15.6999 4.70156 15.4999 4.50156 15.2999 4.50156H13.5999C13.3999 4.50156 13.1999 4.30156 13.1999 4.10156C13.1999 3.50156 12.5999 3.10156 11.9999 3.10156C11.2999 3.10156 10.7999 3.60156 10.7999 4.10156C10.7999 4.30156 10.5999 4.60156 10.3999 4.60156H8.7999C8.5999 4.60156 8.3999 4.80156 8.3999 5.00156V5.50156ZM14.8999 20.8016V18.4016V16.9016C14.8999 16.8016 14.9999 16.7016 15.0999 16.7016H18.0999",
    stroke: "rgb(33 33 33)",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.5L11.5 14L14.5 11",
    stroke: "rgb(33 33 33)",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCriticalUpdates);
export default __webpack_public_path__ + "static/media/criticalUpdates.162d24759c13c224df57bdfe0a64c7d1.svg";
export { ForwardRef as ReactComponent };